import { Flex } from 'mds-web-ui'
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef
} from 'react'

import { useDesktopBreakpoint } from '../mediaQueries'
import { VideoWrapper } from './VideoWrapper'

export const CursorTimelapseVideo = forwardRef(
  (
    {
      src,
      alt,
      showProgress = true,
      autoplay = false,
      aspectRatio = 'initial',
      children,
      ...props
    },
    ref
  ) => {
    const containerRef = useRef()
    const videoRef = useRef()
    const progressRef = useRef()
    useImperativeHandle(ref, () => containerRef.current)

    const isDesktop = useDesktopBreakpoint()

    useEffect(() => {
      const container = containerRef.current
      const video = videoRef.current
      const progress = progressRef.current
      if (!container || !video) {
        return
      }

      if (!isDesktop) {
        return
      }

      const onMouseMove = e => {
        const { left, width } = container.getBoundingClientRect()
        const x = e.clientX - left
        const percent = x / width
        video.currentTime = percent * video.duration

        if (progress) {
          progress.style.setProperty('--progress', `${percent * 100}%`)
        }
      }

      container.addEventListener('mousemove', onMouseMove)

      return () => {
        container.removeEventListener('mousemove', onMouseMove)
      }
    }, [isDesktop])

    const showProgressOnDesktop = showProgress && isDesktop

    return (
      <Flex
        ref={containerRef}
        width="100%"
        height={['75vh', 1080]}
        {...props}
        alignItems="center"
        justifyContent="center"
        css={{
          borderRadius: 12,
          position: 'relative',
          '.timelapse__progress': {
            opacity: 0.5,
            transition: 'opacity 240ms ease-in-out'
          },
          '&:hover': {
            '.timelapse__progress': {
              opacity: 1
            }
          }
        }}
      >
        <VideoWrapper
          src={src}
          alt={alt}
          ref={videoRef}
          autoplay={autoplay}
          css={{ aspectRatio }}
          borderRadius={12}
        />

        {children}

        {showProgressOnDesktop ? (
          <Flex
            className="timelapse__progress"
            ref={progressRef}
            css={{
              '--progress': '0%',
              position: 'absolute',
              borderRadius: 8,
              left: '50%',
              bottom: 20,
              zIndex: 1,
              transform: 'translateX(-50%)',
              overflow: 'hidden',
              pointerEvents: 'none',
              '&::after': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                height: '100%',
                width: '100%',
                borderRadius: 'inherit',
                backgroundColor: '#fff',
                transform: 'translateX(calc(-100% + var(--progress)))'
              }
            }}
            width="50%"
            height={8}
            bg="rgba(0, 0, 0, 0.5)"
          />
        ) : null}
      </Flex>
    )
  }
)
